import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { YachtsApiResponse } from "@/services/YatchManagementService";

interface YachtState {
  yachtsResponse: YachtsApiResponse | null;
}

const initialState: YachtState = {
  yachtsResponse: null,
};

const yachtSlice = createSlice({
  name: "yacht",
  initialState,
  reducers: {
    setYachtsResponse: (state, action: PayloadAction<YachtsApiResponse>) => {
      state.yachtsResponse = action.payload;
    },
  },
});

export const { setYachtsResponse } = yachtSlice.actions;
export default yachtSlice.reducer;
